<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <transition appear
                @before-enter="$animations.beforeEnterLogoArea"
                @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>
<div class="opacity-select-card card px-2 py-5" style="width: 50%; margin: 120px auto 0 auto; " >
    <div class="columns is-centered mb-0">

      <transition appear
                  @before-enter="$animations.beforeEnterBelow"
                  @enter="$animations.enterBelow"
      >
        <div class="column is-9 has-text-centered">
          <img
            src="../assets/images/icons/Blue/charm_circle-tick.png"
            alt="charm_circle-tick.img"
            width="20%"
          />
          <p
            class="is-size-1-desktop mb-3 congratulationText"
            style="line-height: 45px; font-family: OpenSans-Bold"
          >
            {{ $root.selectedLanguageData.congratulations }}
          </p>
          <p class="is-size-5 specific-sentance" style="color: #009ec2">
            {{ $root.selectedLanguageData.ekycregistrationsuccessful }}
          </p>
          <p class="is-size-5 specific-sentance" style="color: #009ec2">
            {{ $root.selectedLanguageData.thankyou }}
          </p>
          <p v-if="$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`" style="font-family: OpenSans-Regular">
            {{
              $root.selectedLanguageData
                .yourdatahasbeensubmittedtooursystemoneofouragentswillconactyousoonguardian
            }}
          </p>
          <p v-else style="font-family: OpenSans-Regular">
            {{
              $root.selectedLanguageData
                .yourdatahasbeensubmittedtooursystemoneofouragentswillconactyousoon
            }}
          </p>
          <b-button
            type="is-primary"
           
            expanded
            @click="displayNewForm()"
            style="font-family: OpenSans-Regular"
            class="mt-5"
            >{{ $root.selectedLanguageData.done }}</b-button
          >
        </div>
      </transition>
    </div>
  </div>
  </div>
</template>
<script>
import Logo from "./NsbKycLogo.vue";
import * as enLanguageData from "@/assets/Lang/en.json";
export default {
  components: {
    Logo,
  },
  data() {
    return {
      isDoneButtonLoading: false,
    };
  },

  methods: {
    /**
     *  A method to display new form to the user
     */
    async getFaceIdDetails(){
      const comp = this;
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
      console.log('kycToken ',kyc_token);
      comp.$http
          .post(this.$baseURL + "/AfterGiftByDonerApplicationSendEmail", {
            header: { "kyc_token":kyc_token },
          })
          .then(function (response) {
            console.log(response.data);

          })
          .catch(function (response) {
            //handle error
            console.log(response);
          });
    },


    displayNewForm() {
      // TODO :: implement the method
      const comp = this;

      // clear previous form variables ------------------------
      comp.$root.formData = {
        countriesList: [], // an array type variable to store all active countries
        idType: "",
        idProofType: "",
        customer_nic: "",
        customer_passport_no: "",
        nicNumberAllowToDRP: true,
        nicNumberAllowToLocationServicesInYourBrowser: true,

        email: "",
        otp: "",

        full_name: "",
        surname: "",
        other_name: "",
        mobileNumber: "",
        account_type: "",
        country: "",
        country_short_name: "",
        countryCode: "",
        branch: "Digital Branch",
        srilankanCurrencyType: "LKR",
        forignCurrencyType: "",
        facility_internet_banking: "",
        facility_debit_card: "",
        facility_debit_card_type: "",
        facility_debit_card_customer_name: "",
        contact_no: "",

        title: "",
        name_with_init: "",
        countryCodeForResidentialContactNum: "",
        resident_country_short_name: "",
        office_country_short_name: "",
        countryCodeForOfficeContactNum: "",
        contact_no_resident: "",
        residentNumber: "",
        officeNumber: "",
        contact_no_work: "",
        gender: "",
        date_of_birth: "",
        marital_status: "",
        spouse_name: "",
        foreign_address_line1: "",
        foreign_address_line2: "",
        foreign_address_line3: "",
        foreign_address_postal_code: "",
        foreign_address_country: "",
        permanent_address_line1: "",
        permanent_address_line2: "",
        permanent_address_line3: "",
        permanent_address_postal_code: "",
        permanent_address_country: "",
        mailing_address_line1: "",
        mailing_address_line2: "",
        mailing_address_line3: "",
        mailing_address_postal_code: "",
        mailing_address_country: "",
        correspondent_address_line1: "",
        correspondent_address_line2: "",
        correspondent_address_line3: "",
        correspondent_address_postal_code: "",
        correspondent_address_country: "",
        residentialAddress: "",
        mailing_address_same_as_permanent_address: false,
        foreignAddress: "",
        selectStateOfPermanentAddress: "",
        citizenship: "Sri Lankan",
        dual_citizen_countries: [],
        foreign_national_country: "",
        residentship: "",
        us_person: "",
        resident_countries: [],
        politically_exposed: "",
        politically_exposed_position: "",
        politically_exposed_relative: "",
        politically_exposed_relative_position: "",

        us_person_account_numbers: "",
        us_person_place_of_birth: "",
        us_person_permanent_address: "",
        permanent_address_in_us_radio: "",
        correspondent_address_in_us: "",
        us_person_correspondent_address: "",
        usTellCountryCode: "",
        us_tel_number: "",
        us_person_telephone_no: "",
        us_person_tax_identification_no: "",
        same_as_above_passport_number: false,
        us_person_passport_no: "",

        residentialProperty: false,
        motorVehicle: false,
        landBuilding: false,
        investmentShares: false,
        others: false,

        purpose_of_opening: "",
        source_of_income: "",
        income_details: "",
        anticipated_vol: "",
        expected_delivery_channel: "",

        valueofresidentialProperty: "",
        valueofmotorVehicle: "",
        valueoflandBuildings: "",
        valueofinvestmentShares: "",
        valueofothers: "",

        other_businesses: "",

        natureOfEmployment: "",
        employment_position: "",
        employer_name: "",
        employer_addr: "",
        employer_name_spouse: "",
        employment_position_spouse: "",
        Otp: "",

        agree_with_the_verification_attached: "",
        introduced_by: "",

        selLang: "",

        currencies: [],
        currency_type_raw: "",
        currency_type_code: "",
        currency_type: "",

        addressProofSameAsNic: false,

        initialOTP: "",
        finalOTP: "",

        kyc_token: "",
        // a variable to store the face id values
        face_ids: {
          nic: null,
          selfie: null,
        },

        location_details: {
          form_submitted: null,
        },

        locationAccess: "",
        nicVerificationDRP: "",

        color_code1:"",
        color_code2:"",
        color_code3:"",
        color_code4:"",
        color_code5:"",
        color_code6:"",
        color_code7:"",
        color_code8:"",
        color_code9:"",
        color_code10:"",
        color_code11:"",
        color_code12:"",
        color_code13:"",
        color_code14:"",
        color_code15:"",
        color_code16:"",
      };

      comp.$root.productImages = {
        nic_front_image: null,
        nic_back_image: null,
        selfie_image: null,
        sign_image: null,
        addr_proof_doc: null,
        passport_image: null,
        visa_proof_doc: null,
      };

      comp.$root.imageurl = {
        nicfrontsideimageurl: null,
        nicbacksideimageurl: null,
        selfie_imageurl: null,
        signature_imageurl: null,
        address_proof_imageurl: null,
        passportimageurl: null,
        visa_proof_imageurl: null,
      };

      comp.$root.keyStrokeStatics = {
        kyc_branch: 0,
        idProofType: 0,
        account_type: 0,
        mobileNumber: 0,
        residentNumber: 0,
        officeNumber: 0,
        us_person: 0.2,
        us_person_account_numbers: 0,
        us_person_place_of_birth: 0,
        us_person_permanent_address: 0,
        us_person_correspondent_address: 1,
        us_person_passport_no: 0,
        us_person_telephone_no: 0,
        dual_citizen_countries: 0.4,
        us_person_tax_identification_no: 0,
        facility_internet_banking: 0,
        facility_debit_card: 0,
        facility_debit_card_type: 0,
        facility_debit_card_customer_name: 0,
        foreign_national_country: 0,
        resident_countries: 0.1,
        visa_proof_doc: 0.1,
        contact_no: 0,
        contact_no_resident: 0.33,
        contact_no_work: 0,
        email: 0,
        title: 0.1,
        name_with_init: 0,
        full_name: 0.3,
        customer_nic: 0,
        gender: 0,
        date_of_birth: 0,
        marital_status: 0,
        spouse_name: 0,
        permenent_addr: 0.09000000000000001,
        address_line_1: 0,
        address_line_2: 0.27,
        address_line_3: 0,
        residential_addr: 0,
        foreign_addr: 0.22,
        residential_ownership: 0,
        citizenship: 0.2,
        residentship: 0,
        politically_exposed: 0,
        politically_exposed_relative: 0.2,
        nature_of_business: 0,
        employment_position: 0,
        employment_position_spouse: 0,
        employer_name: 0.4,
        employer_name_spouse: 0,
        employer_addr: 0,
        purpose_of_opening: 0,
        source_of_income: 0,
        income_details: 0.1,
        anticipated_vol: 0,
        expected_delivery_channel: 0,
        other_businesses: 0,
        nic_front_image: 0,
        nic_back_image: 0,
        passport_image: 0,
        selfie_image: 0,
        sign_image: 0,
        addr_proof_doc: 0,
        asset_residential_property: 0,
        asset_motor_vehicles: 0,
        asset_land_buildings: 0,
        asset_investments_shares: 0,
        asset_other: 0,
        asset_residential_property_value: 0,
        asset_motor_vehicles_value: 0,
        asset_land_buildings_value: 0,
        asset_investments_shares_value: 0,
        asset_other_value: 0.36,
        vas_visa_card: 0,
        vas_visa_card_name: 0,
        vas_lkr_online_purchase: 0,
        vas_fc_transaction: 0,
        vas_sms_alerts: 0,
        vas_sms_alerts_mobile: 0,
        vas_all_transaction_alerts: 0,
        vas_mothers_maiden_name: 0,
        indemnity: 0,
        special_declaration_q1: 0,
        special_declaration_q1_country: 0,
        special_declaration_q2: 0,
        special_declaration_q2_country: 0,
        special_declaration_q3: 0,
        special_declaration_q3_country: 0,
        special_declaration_q4: 0,
        special_declaration_q4_period: 0,
        special_declaration_q5: 0,
        facebook_name: 0,
        linkedin_name: 0,
        twitter_name: 0,

        // newly added fields------------------- 2022-09-22
        foreign_address_line1: 0,
        foreign_address_line2: 0,
        foreign_address_line3: 0,
        foreign_address_postal_code: 0,
        foreign_address_country: 0,
        permanent_address_line1: 0,
        permanent_address_line2: 0,
        permanent_address_line3: 0,
        permanent_address_postal_code: 0,
        permanent_address_country: 0,
        mailing_address_line1: 0,
        mailing_address_line2: 0,
        mailing_address_line3: 0,
        mailing_address_postal_code: 0,
        mailing_address_country: 0,
        correspondent_address_line1: 0,
        correspondent_address_line2: 0,
        correspondent_address_line3: 0,
        correspondent_address_postal_code: 0,
        correspondent_address_country: 0,
        surname: 0,
        other_name: 0,
        customer_passport_no: 0,
      };


      // Keystroke dynamic calculation related variables
      comp.$root.keyStrokeDynamics= {
        // new
        idProofType: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        customer_passport_no: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        customer_nic: {
          type: "text",
              weight: 2,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        nicNumberAllowToLocationServicesInYourBrowser: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        title: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        surname: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        other_name: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mobileNumber: {
          type: "text",
              weight: 1.55,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        residentNumber: {
          type: "text",
              weight: 1.55,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        officeNumber: {
          type: "text",
              weight: 1.55,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        email: {
          type: "text",
              weight: 1.55,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        account_type: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        forignCurrencyType: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        currency_type_code: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        facility_internet_banking: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        facility_debit_card: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        facility_debit_card_type: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        facility_debit_card_customer_name: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        yourNewMail: {
          type: "text",
              weight: 1.55,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        gender: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        date_of_birth: {
          type: "dropdown",
              weight: 1.5,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        marital_status: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        spouse_name: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        citizenship: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        dual_citizen_countries: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        foreign_national_country: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        residentship: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        resident_countries: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_line1: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_line2: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_line3: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_postal_code: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_country: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_same_as_permanent_address: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_line1: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_line2: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_line3: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_postal_code: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        mailing_address_country: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_account_numbers: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_place_of_birth: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        permanent_address_in_us_radio: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_in_us: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_line1: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_line2: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_line3: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_postal_code: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        correspondent_address_country: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        same_as_above_passport_number: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_passport_no: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_tax_identification_no: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        politically_exposed: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        politically_exposed_position: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        politically_exposed_relative: {
          type: "radio",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        politically_exposed_relative_position: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_permanent_address: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        us_person_telephone_no: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        purpose_of_opening: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        source_of_income: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        income_details: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        anticipated_vol: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        expected_delivery_channel: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        employer_name: {
          type: "text",
              weight: 1.5,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        employer_addr: {
          type: "text",
              weight: 1.5,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        nic_front_image: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        nic_back_image: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        selfie_image: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        sign_image: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        addr_proof_doc: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        visa_proof_doc: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        passport_image: {
          type: "file",
              source: null,
              weight: 3,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        introduced_by: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        agree_with_the_verification_attached: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        // old..........................................
        kyc_branch: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        currency_type_raw: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        // newly added fields -------------------------------------------------------------------------------------------------

        // newly added fields ends --------------------------------------------------------------------------------------------
        contact_no: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        contact_no_resident: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        contact_no_work: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        name_with_init: {
          type: "text",
              weight: 1.5,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        full_name: {
          type: "text",
              weight: 1.5,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        address_line_1: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        address_line_2: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        address_line_3: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        residential_addr: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        foreign_addr: {
          type: "text",
              weight: 1.75,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        residential_ownership: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        country_of_birth: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        nationality: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },


        employment_position: {
          type: "dropdown",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        other_businesses: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        facebook_name: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        linkedin_name: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        twitter_name: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        asset_residential_property: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_motor_vehicles: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_land_buildings: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_investments_shares: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_other: {
          type: "checkbox",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },

        asset_residential_property_value: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_motor_vehicles_value: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_land_buildings_value: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_investments_shares_value: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },
        asset_other_value: {
          type: "text",
              weight: 1,
              charCount: 0,
              keyPressCount: 0,
              focusedDuration: 0,
              flags: [],
        },


      }


      comp.$root.focusedInputKey = null;
      // comp.$root.keyStrokeDynamics = {};

      comp.$root.isFormSubmitted = false;
      comp.$root.isEmailError = false;
      comp.$root.isMobileError = false;
      comp.$root.isCountryCodeError = false;

      comp.$root.selectedLanguageData = enLanguageData;
      comp.$root.selectedLanguage = "en";

      comp.$router.push("/");
    },
  },

  mounted() {
    if (!this.$root.isFormSubmitted) {
      this.$router.push("/");
    }
    else if (this.$root.isFormSubmitted && this.$root.formData.isDonorFilled === 1){
      this.getFaceIdDetails()

    }
  },
};
</script>
<style scoped>

@media only screen and (max-width: 500px) {
  .congratulationText{
    font-size:1.3rem;
  }
}
</style>

